"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eaiSavedRequests = void 0;
const helpers_1 = require("./helpers");
const getSavedRequestsUrl = (accountId) => `/accounts/${accountId}/eai-saved-requests`;
const getSavedRequests = (caller) => async (options) => {
    const { accountId, ...restParams } = options;
    const url = getSavedRequestsUrl(accountId);
    return caller(url)
        .get(restParams)
        .then((res) => (res ? { ...res, _data: res._data.map(helpers_1.parseAndValidateRequestedAnalysis) } : null));
};
const getSavedRequest = (caller) => async (options) => {
    const { accountId, id } = options;
    const url = `${getSavedRequestsUrl(accountId)}/${id}`;
    return caller(url).get().then(helpers_1.parseAndValidateRequestedAnalysis);
};
const postSavedRequest = (caller) => (options) => {
    const { accountId, payload } = options;
    const url = getSavedRequestsUrl(accountId);
    return caller(url).post(payload, { withResponse: true });
};
const patchSavedRequest = (caller) => (options) => {
    const { accountId, id, payload } = options;
    const url = `${getSavedRequestsUrl(accountId)}/${id}`;
    return caller(url).patch(payload);
};
const deleteSavedRequest = (caller) => (options) => {
    const { accountId, id } = options;
    const url = `${getSavedRequestsUrl(accountId)}/${id}`;
    return caller(url).delete();
};
const eaiSavedRequests = (caller) => ({
    get: getSavedRequests(caller),
    getById: getSavedRequest(caller),
    post: postSavedRequest(caller),
    patch: patchSavedRequest(caller),
    delete: deleteSavedRequest(caller),
});
exports.eaiSavedRequests = eaiSavedRequests;
//# sourceMappingURL=api.js.map